import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-home',
  imports: [CommonModule, RouterLink],
  templateUrl: './home.html',
  styleUrl: './home.css'
})
export class Home {
  services = [
    {
      title: 'Performance Marketing',
      description: 'Drive growth with data-driven marketing strategies, SEO optimization, and conversion-focused campaigns that deliver measurable results.',
      link: '/performance-marketing',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop'
    },
    {
      title: 'Cloud Audits & Compliance',
      description: 'Ensure security, cost optimization, and regulatory compliance with comprehensive cloud infrastructure audits and expert recommendations.',
      link: '/cloud-compliance',
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400&h=300&fit=crop'
    },
    {
      title: 'DevOps & Automation',
      description: 'Streamline your development pipeline with CI/CD automation, infrastructure as code, and modern DevOps practices for faster delivery.',
      link: '/devops',
      image: 'https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?w=400&h=300&fit=crop'
    },
    {
      title: 'Messaging Services',
      description: 'Build robust, scalable messaging infrastructure with real-time communication solutions, message queues, and event-driven architectures.',
      link: '/messaging',
      image: 'https://images.unsplash.com/photo-1611606063065-ee7946f0787a?w=400&h=300&fit=crop'
    }
  ];

  stats = [
    { value: '500+', label: 'Projects Completed' },
    { value: '98%', label: 'Client Satisfaction' },
    { value: '25+', label: 'Countries Served' },
    { value: '50+', label: 'Team Experts' }
  ];

  testimonials = [
    {
      quote: 'HoneyKode\'s performance marketing expertise transformed our digital presence. We saw a 300% increase in qualified leads within just three months.',
      author: 'Sarah Mitchell',
      role: 'VP of Marketing, TechVentures Inc',
      avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces',
      initials: 'SM'
    },
    {
      quote: 'Their cloud audit saved us thousands in monthly costs while improving our security posture. The team is professional, thorough, and responsive.',
      author: 'James Rodriguez',
      role: 'CTO, CloudScale Solutions',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=faces',
      initials: 'JR'
    },
    {
      quote: 'The DevOps automation implementation reduced our deployment time from days to minutes. Exceptional technical expertise and project management.',
      author: 'Emily Chen',
      role: 'Engineering Director, DataFlow Systems',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=faces',
      initials: 'EC'
    },
    {
      quote: 'Building our messaging infrastructure with HoneyKode was seamless. They understood our scalability needs and delivered a robust, future-proof solution.',
      author: 'Michael Thompson',
      role: 'CEO, MessageHub Pro',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=faces',
      initials: 'MT'
    }
  ];

  partners = [
    'AWS Partner',
    'Google Cloud Partner',
    'Microsoft Azure',
    'Salesforce',
    'HubSpot',
    'Docker',
    'Kubernetes',
    'Terraform'
  ];

  whyChooseUs = [
    {
      title: 'Industry Expertise',
      description: 'Deep knowledge across cloud platforms, marketing technologies, and modern development practices.',
      icon: 'expertise'
    },
    {
      title: 'Proven Track Record',
      description: '500+ successful projects delivered across 25+ countries with 98% client satisfaction rate.',
      icon: 'track-record'
    },
    {
      title: 'Cutting-Edge Technology',
      description: 'We leverage the latest tools and technologies to ensure your solutions are future-proof and scalable.',
      icon: 'technology'
    },
    {
      title: 'Dedicated Support',
      description: '24/7 support and maintenance to ensure your systems run smoothly with minimal downtime.',
      icon: 'support'
    }
  ];
}
